import store from '@/store'
import H_act from '@/helpers/act';
import H_time from '@/helpers/time';
import H_common from '@/helpers/common';
import H_factoryTag from '@/helpers/factoryTag';

export default {
  setShow({
    id,
    factory_tags,
    guideline_status,
    is_collect: isCollect = false,
    last_version,
  }) {
    return {
      id,
      versionId: last_version ? last_version.id : '',
      lastVersion: last_version ? last_version : {},
      isCollect,
      factoryTags: H_factoryTag.setShowInModule(factory_tags),
      guidelineStatus: guideline_status ? guideline_status.name : '無',
    }
  },
  setCard(rawDataList) {
    if (!rawDataList || !rawDataList.length) return [];
    return rawDataList.map(({
      id,
      type,
      name,
      announce_at,
      guideline,
      guideline_version,
    }) => {
      return {
        id,
        type,
        title: `${name}${announce_at ? ` (${H_time.getDateDashFormat(announce_at)})` : ''}`,
        guidelineId: guideline ? guideline.id : '',
        guidelineVerId: guideline_version ? guideline_version.id : '',
      };
    });
  },
  setIndex(rawDataList) {
    return rawDataList.map(({
      id,
      guideline_status,
      last_version,
      factory_tags,
      has_unreleased,
      is_collect: isCollect = false,
    }) => {
      const hasUnreleased = has_unreleased === 1
        ? {
            text: '未發布',
            color: 'yellow',
          }
        : {
            text: '發布',
            color: 'green',
          };
      const {
        id: versionId='',
        name='',
        announce_at='',
      } = last_version ? last_version : {};
      const updateDateBadge = H_act.setActUpdateDateBadge(announce_at);
      return {
        id,
        versionId,
        name: {
          text: name,
          chips: [
            ...(updateDateBadge ? [{
              name: updateDateBadge,
              color: 'yellow',
            }] : []),
            ...H_common.setFactoryTagsInDataTable(factory_tags),
          ],
        },
        guidelineStatus: guideline_status
          ? {
              text: guideline_status.name,
              color: 'yellow',
            }
          : {
              text: '無',
              color: 'yellow',
            },
        announceAt: H_time.getDateDashFormat(announce_at),
        hasUnreleased,
        isCollect,
      };
    })
  },
  setIndexParams(filterState) {
    const {search, factoryTags, hasUnreleased, duration, guidelineStatus} = filterState;
      const {start, end} = duration;
      let baseParams = {
        factory: store.state.app.factory.id,
        order_by: 'announce_at',
        order_way: 'desc',
        guideline_status: guidelineStatus.toString(),
        factory_tags: factoryTags.toString(),
      };
      if (search) baseParams.search = search;
      if (start && end) baseParams = {
        ...baseParams,
        time_field: 'announce_at',
        start_time: start,
        end_time: end,
      };
      if (hasUnreleased) baseParams.has_unreleased = hasUnreleased.toString();
      return baseParams;
  },
  async clickRelatedGuideline(t, $event) {
    if (!t) return;
    const {
      type,
      guidelineId,
      guidelineVerId,
      articleVerId,
    } = $event;
    if (type === 'guideline' || type === 'title') {
      const query = {};
      if (type === 'title') query.articleVerId = articleVerId;
      if (guidelineVerId) query.versionId = guidelineVerId;
      const url = t.$router.resolve({
        path: `/factory/${store.state.app.factory.id}/guideline-content/${guidelineId}`,
        query,
      });
      window.open(url.href, '_blank');
    } else if (type === 'article') {
      await t.$refs.LvPopupInfoArticle.$_onOpenPopup(null, $event);
    }
  }
}